import { render, staticRenderFns } from "./DailyReportsList.vue?vue&type=template&id=172240e5&"
import script from "./DailyReportsList.vue?vue&type=script&lang=js&"
export * from "./DailyReportsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports